import React, { useEffect, useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import {
    CButton, CCard, CCardBody, CCardHeader
} from '@coreui/react';

import { apiClient } from 'services/Api';
import DataTableComponent from "components/DataTableComponent";
import AlertNotification from 'components/globals/AlertNotification';
import RecordDetailOffcanvas from "components/RecordDetailOffcanvas";

const PartnershipList = () => {
    const navigate = useNavigate();
    const [partnerships, setPartnerships] = useState([]);
    const location = useLocation();
    const [previewPartnership, setPreviewPartnership] = useState(null);

    useEffect(() => {
        const fetchSuppliers = async () => {
            try {
                const response = await apiClient.get(`/partnerships/`);
                setPartnerships(response.data);
                setPreviewPartnership((current) => current
                    ? response.data.find((partnership) => partnership.id === current.id) || null
                    : null);
            } catch (error) {
                console.error('Error fetching partnerships:', error);
            }
        };

        fetchSuppliers();
    }, [location.pathname]);

    const handleDelete = async (partnershipId) => {
        try {
            await apiClient.delete(`/partnerships/${partnershipId}/`);
            setPartnerships((current) => current.filter((partnership) => partnership.id !== partnershipId));
            setPreviewPartnership((current) => current?.id === partnershipId ? null : current);
        } catch (error) {
            console.error('Error deleting partnership:', error);
        }
    };

    const columns = [
        { name: "Entidade", selector: (row) => row.name, sortable: true, className: 'text-center' },
        { name: "Tipo", selector: (row) => row.partnership_type, sortable: true, className: 'text-center' },
        { name: "Âmbito", selector: (row) => row.scope, sortable: true, className: 'text-center' },
        { name: "Data de Início", selector: (row) => row.start_date, sortable: true, className: 'text-center' },
        { name: "Estado", selector: (row) => row.active ? "Ativa" : "Inativa", sortable: true, className: 'text-center' },
        { name: "Data de Fim", selector: (row) => row.end_date, sortable: true, className: 'text-center' },
        { name: "Eficácia", selector: (row) => row.efficiency, sortable: true, className: 'text-center' },
    ];

    return (
        <>
            <AlertNotification />
            <CCard>
                <CCardHeader className="d-flex justify-content-between align-items-center">
                    <h3 className="mb-0">Parcerias</h3>
                    <Link to="/parcerias/new">
                        <CButton color="info" className="text-white">Nova Parceria</CButton>
                    </Link>
                </CCardHeader>
                <CCardBody>
                    <DataTableComponent
                        columns={columns}
                        data={partnerships}
                        onRowClicked={setPreviewPartnership}
                    />
                </CCardBody>
            </CCard>
            <RecordDetailOffcanvas
                record={previewPartnership}
                onHide={() => setPreviewPartnership(null)}
                title="Parceria"
                subtitle={previewPartnership?.name}
                fields={previewPartnership ? [
                    { label: "Entidade", value: previewPartnership.name },
                    { label: "Tipo", value: previewPartnership.partnership_type },
                    { label: "Âmbito", value: previewPartnership.scope },
                    { label: "Data de Início", value: previewPartnership.start_date },
                    { label: "Estado", value: previewPartnership.active ? "Ativa" : "Inativa" },
                    { label: "Data de Fim", value: previewPartnership.end_date },
                    { label: "Eficácia", value: previewPartnership.efficiency },
                ] : []}
                headerActions={previewPartnership && <>
                    <CButton color="info" variant="outline" size="sm" onClick={() => navigate(`/parcerias/${previewPartnership.id}`)}>
                        Ver/Editar
                    </CButton>
                    <CButton color="danger" size="sm" className="text-white" onClick={() => handleDelete(previewPartnership.id)}>
                        Eliminar
                    </CButton>
                </>}
            />
        </>
    );
};

export default PartnershipList;
